// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stories-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 35px;
  width: 100%;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.story-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 56px;
  cursor: pointer;
}

.story-image-container {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.story-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.story-title {
  margin-top: 7px;
  font-size: 0.8em;
  text-align: center;
}

@media (min-width: 1024px) {
  .stories-container {
      gap: 50px;
  }

  .story-item {
      min-width: 80px;
  }

  .story-image-container {
      width: 80px;
      height: 80px;
      border: 3px solid rgba(79, 182, 255, 0.338);
      padding: 3px;
      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);
  }

  .story-title {
      margin-top: 10px;
      font-size: 0.9em;
  }
}

@media (max-width: 1024px) {
  .stories-container {
      gap: 45px;
  }

  .story-item {
      min-width: 70px;
  }

  .story-image-container {
      width: 70px;
      height: 70px;
      border: 2.5px solid rgba(79, 182, 255, 0.338);
      padding: 2.5px;
      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);
  }

  .story-title {
      margin-top: 8px;
      font-size: 0.85em;
  }
}

@media (max-width: 1024px) {
  .stories-container {
      gap: 30px;
  }

  .story-item {
      min-width: 60px;
  }

  .story-image-container {
      width: 80px;
      height: 80px;
      border: 2px solid rgba(79, 182, 255, 0.338);
      padding: 1.8px;
      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);
  }

  .story-title {
      margin-top: 6px;
      font-size: 0.75em;
  }
}

@media (max-width: 650px) {
  .stories-container {
      gap: 30px;
  }

  .story-item {
      min-width: 60px;
  }

  .story-image-container {
      width: 70px;
      height: 70px;
      border: 2px solid rgba(79, 182, 255, 0.338);
      padding: 1.8px;
      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);
  }

  .story-title {
      margin-top: 6px;
      font-size: 0.75em;
  }
}

@media (max-width: 480px) {
  .stories-container {
      gap: 20px;
  }

  .story-item {
      min-width: 50px;
  }

  .story-image-container {
      width: 60px;
      height: 60px;
      border: 1.5px solid rgba(79, 182, 255, 0.338);
      padding: 1.5px;
      box-shadow: 0 0 3px rgba(79, 182, 255, 0.338);
  }

  .story-title {
      margin-top: 5px;
      font-size: 0.7em;
  }
}



`, "",{"version":3,"sources":["webpack://./src/style/Stories.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;MACI,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,2CAA2C;MAC3C,YAAY;MACZ,6CAA6C;EACjD;;EAEA;MACI,gBAAgB;MAChB,gBAAgB;EACpB;AACF;;AAEA;EACE;MACI,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,6CAA6C;MAC7C,cAAc;MACd,6CAA6C;EACjD;;EAEA;MACI,eAAe;MACf,iBAAiB;EACrB;AACF;;AAEA;EACE;MACI,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,2CAA2C;MAC3C,cAAc;MACd,6CAA6C;EACjD;;EAEA;MACI,eAAe;MACf,iBAAiB;EACrB;AACF;;AAEA;EACE;MACI,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,2CAA2C;MAC3C,cAAc;MACd,6CAA6C;EACjD;;EAEA;MACI,eAAe;MACf,iBAAiB;EACrB;AACF;;AAEA;EACE;MACI,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,6CAA6C;MAC7C,cAAc;MACd,6CAA6C;EACjD;;EAEA;MACI,eAAe;MACf,gBAAgB;EACpB;AACF","sourcesContent":[".stories-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 35px;\n  width: 100%;\n  flex-wrap: wrap;\n  overflow-x: hidden;\n}\n\n.story-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 56px;\n  cursor: pointer;\n}\n\n.story-image-container {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.story-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.story-title {\n  margin-top: 7px;\n  font-size: 0.8em;\n  text-align: center;\n}\n\n@media (min-width: 1024px) {\n  .stories-container {\n      gap: 50px;\n  }\n\n  .story-item {\n      min-width: 80px;\n  }\n\n  .story-image-container {\n      width: 80px;\n      height: 80px;\n      border: 3px solid rgba(79, 182, 255, 0.338);\n      padding: 3px;\n      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);\n  }\n\n  .story-title {\n      margin-top: 10px;\n      font-size: 0.9em;\n  }\n}\n\n@media (max-width: 1024px) {\n  .stories-container {\n      gap: 45px;\n  }\n\n  .story-item {\n      min-width: 70px;\n  }\n\n  .story-image-container {\n      width: 70px;\n      height: 70px;\n      border: 2.5px solid rgba(79, 182, 255, 0.338);\n      padding: 2.5px;\n      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);\n  }\n\n  .story-title {\n      margin-top: 8px;\n      font-size: 0.85em;\n  }\n}\n\n@media (max-width: 1024px) {\n  .stories-container {\n      gap: 30px;\n  }\n\n  .story-item {\n      min-width: 60px;\n  }\n\n  .story-image-container {\n      width: 80px;\n      height: 80px;\n      border: 2px solid rgba(79, 182, 255, 0.338);\n      padding: 1.8px;\n      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);\n  }\n\n  .story-title {\n      margin-top: 6px;\n      font-size: 0.75em;\n  }\n}\n\n@media (max-width: 650px) {\n  .stories-container {\n      gap: 30px;\n  }\n\n  .story-item {\n      min-width: 60px;\n  }\n\n  .story-image-container {\n      width: 70px;\n      height: 70px;\n      border: 2px solid rgba(79, 182, 255, 0.338);\n      padding: 1.8px;\n      box-shadow: 0 0 5px rgba(79, 182, 255, 0.338);\n  }\n\n  .story-title {\n      margin-top: 6px;\n      font-size: 0.75em;\n  }\n}\n\n@media (max-width: 480px) {\n  .stories-container {\n      gap: 20px;\n  }\n\n  .story-item {\n      min-width: 50px;\n  }\n\n  .story-image-container {\n      width: 60px;\n      height: 60px;\n      border: 1.5px solid rgba(79, 182, 255, 0.338);\n      padding: 1.5px;\n      box-shadow: 0 0 3px rgba(79, 182, 255, 0.338);\n  }\n\n  .story-title {\n      margin-top: 5px;\n      font-size: 0.7em;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
